import { cookieService } from '@bfa/nextjs-common/services';
import { NextPageContext } from 'next';

import CookieName from '../cookieName';
type ToggledProgramCookieValue = string | undefined;

/**
 * Extracts the program from toggled_subscription_program cookie value.
 *
 * @param ctx NextPageContext
 * @returns
 */
export default function getToggledProgram(
  ctx: NextPageContext
): ToggledProgramCookieValue {
  const toggledSubscription = cookieService.getCookie(
    ctx,
    CookieName.TOGGLED_SUBSCRIPTION_PROGRAM
  );

  if (toggledSubscription) {
    return toggledSubscription.split('|')[1];
  }
}
